import { Sparkles } from "lucide-react";
import {
  DailyBriefParamsSchema,
  defaultDailyBriefParams,
  type DailyBriefParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { DailyBriefWidget } from "./Component.js";

/**
 * Daily Brief — AI dashboard widget (AI, full-width). PlayerAI's morning
 * narrative: headline + narrative + status-toned highlights. Content is MOCKED
 * today and rides the saved params; the AIS swap is drop-in (ADR-0012 / 0007).
 * Self-contained: `TView` defaults to `TParams` (`DailyBriefParams`) — no host
 * resolution. No per-instance editor. The canvas-only `SqlWidgetDef` fields are
 * neutral filler — this kind is dashboard-only (`modes: ["dashboard"]`).
 */
export const dailyBriefDef: SqlWidgetDef<DailyBriefParams> = {
  kind: "dailyBrief",
  label: "Daily Brief",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 240 },
  defaultParams: defaultDailyBriefParams,
  Component: DailyBriefWidget,
  storage: "sql",
  schema: DailyBriefParamsSchema,
  accent: "purple",
  icon: Sparkles,
  subtitle: "PlayerAI's morning brief",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 1, width: 960, height: 240 },
  dashboard: {
    icon: Sparkles,
    defaultWidth: "full",
    category: "AI",
  },
};

registerWidget(dailyBriefDef);
